import { Metrika } from '../components/metrika';

export function goals() {
    const metrika = new Metrika;

    // Кнопка "Перезвоните мне" в header
    let headerBtn = document.querySelector('[am-btn="header"]');
    headerBtn.addEventListener('click', function() {
        metrika.reachGoal('recallme_btn_in_header', this);
    });

    // Кнопка "Получить консультацию" в бургере
    let burgerBtn = document.querySelector('[am-btn="burger"]');
    burgerBtn.addEventListener('click', function() {
        metrika.reachGoal('getconsultation_btn_in_burger', this);
    });

    //  Фиксированая кнопка "Получить консультацию" на мобильном аб тест
    let fixedBtn = document.querySelector('[am-block="fixedBtn"] button');
    fixedBtn.addEventListener('click', function() {
        metrika.reachGoal('get_consultation_fixed_btn_in_mobile', this);
    });

}